const defaultDisplayValue = '--:--';
const defaults = { defaultDisplayValue };
export default defaults;
